module.exports = __webpack_public_path__ + "img/590syd2.e6c66686.png";